import http from './http';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import md5 from 'crypto-js/md5';
import { randomUUID } from 'cfmoto-utils';
import envConfig from '@/config';
import { getCustomAgent } from '@/utils';

function decodeDataComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

// export const burialPointApi = (params0 = {}, config = {}) => http.post(`/cfmotoserverapp/dbpoint/send`, params0, { ...config });
export const burialPointApi = (params0 = {}, config = {}) => {
  const headers = { 'Content-Type': 'application/json;charset=UTF-8', ...(config.headers || {}) };

  const ticket = JSON.parse(localStorage.getItem('token') || '""')
    .replace(/[bB]earer/, '')
    .trim();
  if (ticket && !headers['Authorization']) {
    headers['Authorization'] = `Bearer ${ticket}`;
  } else {
    headers['Authorization'] = `a1398a17-0890-4ab1-9df3-be9e2aa40615`;
  }
  const user_id = JSON.parse(localStorage.getItem('user_id') || '""');
  if (user_id) {
    headers['user_id'] = user_id;
  }

  const appConfig = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_CONFIG`];
  // const params = JSON.parse(JSON.stringify({}));
  const query = decodeURIComponent(qs.stringify({}, { arrayFormat: 'repeat' }));
  const data = decodeDataComponent(!Object.keys(params0 || {}).length || params0 instanceof FormData ? '' : typeof params0 === 'string' ? params0 : JSON.stringify(params0 || ''));

  const queryError = /error/.test(window.location.href) ? '&error=' + new Date().getTime() : '';
  const nonce = randomUUID();
  const timestamp = new Date().getTime();
  const signature = `${query}${queryError}${data}appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}${appConfig.appSecret}`;
  const signatureMd5 = md5(sha1(signature).toString()).toString();
  const signatureParam = `appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}`;

  headers['Cfmoto-X-Sign'] = `${signatureMd5}`;
  headers['Cfmoto-X-Sign-Type'] = `0`;
  headers['Cfmoto-X-Param'] = `${signatureParam}`;
  headers['Zeeho-User-Agent'] = getCustomAgent();

  // if (params0.uuid) {
  //   window.localStorage.setItem('viewDurationParams', JSON.stringify(data));
  //   fetch(`http://10.32.173.110:16001/api-admin/auth/user/login?eventData=${encodeURIComponent(JSON.stringify(params0))}`, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json;charset=UTF-8', user_id: user_id },
  //     body: JSON.stringify({ username: 'admin', password: '8fde913ec3ffd20086bb5c3edfbe4ba33', captchaId: 'dd', captchaCode: 'dd' }),
  //   });
  // }
  return fetch(`${baseURL}/cfmotoserverapp/dbpoint/send`, {
    method: 'POST',
    headers,
    body: data,
  }).then((res) => {
    return res.json();
  });
};
export const getBaseInfoApi = (params, config) => http.get('/cfmotoservermine/baseInfo', { params, ...config });

export default {};
